import type { SubmissionSummary } from '../api/types'

/**
 * `last_error` is only ever written by the posting-crash handler and is
 * never cleared once a submission later succeeds through a retry unless the
 * caller explicitly clears it. Gate the drawer's failure banner on the
 * submission still actually being in `post_failed` so a stale message from
 * an earlier crash doesn't linger on a submission that has since posted.
 */
export function shouldShowLastError(s: SubmissionSummary): boolean {
  return s.status === 'post_failed' && Boolean(s.last_error)
}
